import { hasKey, isObject, isString } from "../core/utils";
import { DatasetConfig, Filter } from "./config";

export type ArticleDataValue = string | Array<string>;

export interface Article {
  id: string;
  data: Record<string, ArticleDataValue>;
  position: [number, number];
  shortDescription: string | null;
  raw: string;
}

export interface ColumnPair {
  column: string;
  value: string;
}

export interface DataSourceContextValue {
  csvHeader: Array<string>;
  config: DatasetConfig<string>;
  mapboxToken: string;
  markdownTemplate: string;
  articles: Array<Article>;
  allArticles: Array<Article>;
  focused: Article | null;
  tempArticle: Article | null;
  filters: Array<Filter>;
  mapHighlight: Array<ColumnPair> | null;
  setFocused: (article: Article | null) => void;
  setTempArticle: (article: Article | null) => void;
  setFilters: (filters: Array<Filter>) => void;
  setMapHighlight: (mapHighlight: Array<ColumnPair> | null) => void;
}

export interface GoogleDriveSource {
  type: "GoogleSheets";
  spreadsheet: string;
}

export interface CSVSource {
  type: "CSV";
  url: string;
}

export type Source = CSVSource | GoogleDriveSource;

export function valueArray(data: ArticleDataValue): Array<string> {
  return Array.isArray(data) ? data : [data];
}

export function isColumnPair(value: unknown): value is ColumnPair {
  return (
    isObject(value) &&
    hasKey(value, "column", isString) &&
    hasKey(value, "value", isString)
  );
}
